export enum FileUploadType {
  Profile = 'profile',
  Image = 'image',
  Banner = 'banner',
}
